import { render, staticRenderFns } from "./UsersIndex.vue?vue&type=template&id=6209fdb0&"
import script from "./UsersIndex.vue?vue&type=script&lang=ts&"
export * from "./UsersIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports